import React from 'react';

const ManagementSVG = ({ width, height }) => (
	<svg
        width={width || '41px'}
		height={height || '60px'}
		viewBox="0 0 41 60"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>D257F237-FAD8-41DE-8825-B882715AB0CB@1x</title>
		<desc>Created with sketchtool.</desc>
		<g
			id="NEW-2"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Services"
				transform="translate(-839.000000, -2818.000000)"
				fill="#32C878"
			>
				<g id="Group-19" transform="translate(230.000000, 2811.000000)">
					<g
						id="noun_clipboard_2891381"
						transform="translate(609.000000, 7.000000)"
					>
						<g id="Group">
							<path
								d="M20.2040816,0 C23.5102041,0 26.4489796,2.20408163 27.4285714,5.26530612 L30.3673469,5.26530612 C31.3469388,5.26530612 31.9591837,6 31.9591837,6.85714286 L31.9591837,8.81632653 L35.2653061,8.81632653 C38.0816327,8.81632653 40.4081633,11.1428571 40.4081633,14.0816327 L40.4081633,54.7346939 C40.4081633,57.5510204 38.0816327,60 35.2653061,60 L5.26530612,60 C2.32653061,60 4.08562073e-13,57.5510204 4.08562073e-13,54.7346939 L4.08562073e-13,14.0816327 C4.08562073e-13,11.1428571 2.32653061,8.81632653 5.26530612,8.81632653 L8.44897959,8.81632653 L8.44897959,6.85714286 C8.44897959,6 9.18367347,5.26530612 10.0408163,5.26530612 L12.9795918,5.26530612 C13.9591837,2.20408163 16.8979592,0 20.2040816,0 Z M31.9591837,12 L31.9591837,13.9591837 C31.9591837,14.8163265 31.2244898,15.5510204 30.3673469,15.5510204 L10.0408163,15.5510204 C9.18367347,15.5510204 8.44897959,14.8163265 8.44897959,13.9591837 L8.44897959,12 L5.26530612,12 C4.04081633,12 3.06122449,12.8571429 3.06122449,14.0816327 L3.06122449,54.7346939 C3.06122449,55.8367347 4.04081633,56.8163265 5.26530612,56.8163265 L35.2653061,56.8163265 C36.3673469,56.8163265 37.3469388,55.8367347 37.3469388,54.7346939 L37.3469388,14.0816327 C37.3469388,12.8571429 36.3673469,12 35.2653061,12 L31.9591837,12 Z M20.2040816,3.06122449 C18,3.06122449 16.0408163,4.7755102 15.7959184,6.97959184 C15.6734694,7.83673469 15.0612245,8.44897959 14.2040816,8.44897959 L11.6326531,8.44897959 L11.6326531,12.3673469 L28.8979592,12.3673469 L28.8979592,8.44897959 L26.2040816,8.44897959 C25.4693878,8.44897959 24.7346939,7.83673469 24.6122449,6.97959184 C24.3673469,4.7755102 22.5306122,3.06122449 20.2040816,3.06122449 Z"
								id="Shape"
								fill-rule="nonzero"
							/>
							<path
								d="M20.2040816,5.14285714 C21.3061224,5.14285714 22.2857143,6.12244898 22.2857143,7.2244898 C22.2857143,8.32653061 21.3061224,9.30612245 20.2040816,9.30612245 C19.1020408,9.30612245 18.122449,8.32653061 18.122449,7.2244898 C18.122449,6.12244898 19.1020408,5.14285714 20.2040816,5.14285714 Z"
								id="Path"
							/>
							<path
								d="M8.08163265,23.5102041 C7.2244898,23.5102041 6.48979592,22.7755102 6.48979592,21.9183673 C6.48979592,21.0612245 7.2244898,20.3265306 8.08163265,20.3265306 L21.6734694,20.3265306 C22.5306122,20.3265306 23.2653061,21.0612245 23.2653061,21.9183673 C23.2653061,22.7755102 22.5306122,23.5102041 21.6734694,23.5102041 L8.08163265,23.5102041 Z"
								id="Path"
								fill-rule="nonzero"
							/>
							<path
								d="M8.08163265,32.5714286 C7.2244898,32.5714286 6.48979592,31.8367347 6.48979592,30.9795918 C6.48979592,30.122449 7.2244898,29.3877551 8.08163265,29.3877551 L31.3469388,29.3877551 C32.2040816,29.3877551 32.9387755,30.122449 32.9387755,30.9795918 C32.9387755,31.8367347 32.2040816,32.5714286 31.3469388,32.5714286 L8.08163265,32.5714286 Z"
								id="Path"
								fill-rule="nonzero"
							/>
							<path
								d="M8.08163265,41.6326531 C7.2244898,41.6326531 6.48979592,40.8979592 6.48979592,40.0408163 C6.48979592,39.1836735 7.2244898,38.4489796 8.08163265,38.4489796 L31.3469388,38.4489796 C32.2040816,38.4489796 32.9387755,39.1836735 32.9387755,40.0408163 C32.9387755,40.8979592 32.2040816,41.6326531 31.3469388,41.6326531 L8.08163265,41.6326531 Z"
								id="Path"
								fill-rule="nonzero"
							/>
							<path
								d="M8.08163265,50.6938776 C7.2244898,50.6938776 6.48979592,49.9591837 6.48979592,49.1020408 C6.48979592,48.244898 7.2244898,47.5102041 8.08163265,47.5102041 L31.3469388,47.5102041 C32.2040816,47.5102041 32.9387755,48.244898 32.9387755,49.1020408 C32.9387755,49.9591837 32.2040816,50.6938776 31.3469388,50.6938776 L8.08163265,50.6938776 Z"
								id="Path"
								fill-rule="nonzero"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default ManagementSVG;
